import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['sentence', 'sentenceRaw'];

  openHighlightModal(event) {
    event.preventDefault();

    const sentence = this.sentenceTarget?.value?.trim();
    const sentenceRaw = this.sentenceRawTarget?.value?.trim();

    if (!sentence && !sentenceRaw) return;

    const studyFrame = document.querySelector("#admin_studies_study_body");

    if (studyFrame && studyFrame.innerHTML.trim() !== "") {
      this.highlightSentence(sentence, sentenceRaw);
    } else {
      studyFrame.addEventListener("turbo:frame-load", () => {
        this.highlightSentence(sentence, sentenceRaw);
      }, { once: true });

      studyFrame.src = event.currentTarget.href;
    }
  }

  highlightSentence(sentence, sentenceRaw) {
    const studyFrame = document.querySelector("#admin_studies_study_body");
    if (!studyFrame) return;

    const studyBody = studyFrame.querySelector(".box-content");
    if (!studyBody) return;

    studyBody.querySelectorAll(".sentence-highlight").forEach(el => {
      el.outerHTML = el.innerHTML;
    });

    const cleanInnerHTML = studyBody.innerHTML;
    let match = null;

    if (sentenceRaw) {
      match = cleanInnerHTML.match(new RegExp(_.escapeRegExp(sentenceRaw), "i"));
    }

    if (!match && sentence) {
      match = cleanInnerHTML.match(new RegExp(_.escapeRegExp(sentence), "i"));
    }

    const words = sentenceRaw.trim().split(/\s+/);

    if (!match && sentenceRaw && words.length >= 4) {
      const firstTwo = words.slice(0, 2).join(' ');
      const lastTwo = words.slice(-2).join(' ');

      // Match sentences: assume sentence ends with . ? ! characters
      const sentences = cleanInnerHTML.match(/[^.!?]*[.!?]/g) || [];

      for (const s of sentences) {
        const trimmedSentence = s.trim();
        if (
          trimmedSentence.toLowerCase().startsWith(firstTwo.toLowerCase()) &&
          trimmedSentence.toLowerCase().endsWith(lastTwo.toLowerCase())
        ) {
          match = [trimmedSentence];
          break;
        }
      }

      // If no match found search whole text for part of the sentence
      const windowSize = 4 + Math.floor(words.length / 8);
      for (let i = 0; i <= words.length - windowSize; i++) {
        const phrase = words.slice(i, i + windowSize).join(' ');
        const regex = new RegExp(_.escapeRegExp(phrase), "gi");
        const matches = [...cleanInnerHTML.matchAll(regex)];

        if (matches.length === 1) {
          match = matches[0];
          break;
        }
      }
    }

    if (match) {
      studyBody.innerHTML = cleanInnerHTML.replace(
        match[0],
        `<span class="sentence-highlight">${match[0]}</span>`
      );

      const highlightedElement = studyBody.querySelector(".sentence-highlight");
      if (highlightedElement) {
        highlightedElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }
}
